import { FC, useCallback, useEffect, useRef, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { isNotEmpty, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { initialUser, Automation } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { UsersListLoading } from '../components/loading/UsersListLoading'
import { createAutomations, updateAutomation, } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { PasswordMeterComponent } from '../../../../../../_metronic/assets/ts/components'
import { useCompanies } from '../../../../auth/core/Companies'
import { Cron } from '@impelsys/react-js-cron-mui';
import { toast, ToastContainer } from 'react-toastify'
import Select from 'react-select'
import { auto } from '@popperjs/core'

type Props = {
  isUserLoading: boolean
  automation: Automation
}



const AutomationEditForm: FC<Props> = ({ automation, isUserLoading }) => {
  const { setItemIdForUpdate, } = useListView()
  const { refetch } = useQueryResponse()
  const { defaultCompany, companies, updateDefaultCompany } = useCompanies()
  const defaultValue = '* * * * * *'
  const [value, setValue] = useState(defaultValue)
  const userListContext = useListView()
  const [options, setoptions]:any = useState([]);
  const [selectedTimeZone, setSelectedTimeZone] = useState({
    value: 'America/Chicago',
    label: 'America/Chicago',
  });
  const [timezonelist,setTimezonelist]:any = useState([
    'Asia/Kabul',
'Europe/Tirane',
'Africa/Algiers',
'Pacific/Pago_Pago',
'Europe/Andorra',
'Africa/Luanda',
'America/Anguilla',
'Antarctica/Casey',
'Antarctica/Davis',
'Antarctica/DumontDUrville',
'Antarctica/Mawson',
'Antarctica/McMurdo',
'Antarctica/Palmer',
'Antarctica/Rothera',
'Antarctica/Syowa',
'Antarctica/Troll',
'Antarctica/Vostok',
'America/Antigua',
'America/Argentina/Buenos_Aires',
'America/Argentina/Catamarca',
'America/Argentina/Cordoba',
'America/Argentina/Jujuy',
'America/Argentina/La_Rioja',
'America/Argentina/Mendoza',
'America/Argentina/Rio_Gallegos',
'America/Argentina/Salta',
'America/Argentina/San_Juan',
'America/Argentina/San_Luis',
'America/Argentina/Tucuman',
'America/Argentina/Ushuaia',
'Asia/Yerevan',
'America/Aruba',
'Antarctica/Macquarie',
'Australia/Adelaide',
'Australia/Brisbane',
'Australia/Broken_Hill',
'Australia/Darwin',
'Australia/Eucla',
'Australia/Hobart',
'Australia/Lindeman',
'Australia/Lord_Howe',
'Australia/Melbourne',
'Australia/Perth',
'Australia/Sydney',
'Europe/Vienna',
'Asia/Baku',
'America/Nassau',
'Asia/Bahrain',
'Asia/Dhaka',
'America/Barbados',
'Europe/Minsk',
'Europe/Brussels',
'America/Belize',
'Africa/Porto-Novo',
'Atlantic/Bermuda',
'Asia/Thimphu',
'America/La_Paz',
'America/Kralendijk',
'Europe/Sarajevo',
'Africa/Gaborone',
'America/Araguaina',
'America/Bahia',
'America/Belem',
'America/Boa_Vista',
'America/Campo_Grande',
'America/Cuiaba',
'America/Eirunepe',
'America/Fortaleza',
'America/Maceio',
'America/Manaus',
'America/Noronha',
'America/Porto_Velho',
'America/Recife',
'America/Rio_Branco',
'America/Santarem',
'America/Sao_Paulo',
'Indian/Chagos',
'Asia/Brunei',
'Europe/Sofia',
'Africa/Ouagadougou',
'Africa/Bujumbura',
'Asia/Phnom_Penh',
'Africa/Douala',
'America/Atikokan',
'America/Blanc-Sablon',
'America/Cambridge_Bay',
'America/Creston',
'America/Dawson',
'America/Dawson_Creek',
'America/Edmonton',
'America/Fort_Nelson',
'America/Glace_Bay',
'America/Goose_Bay',
'America/Halifax',
'America/Inuvik',
'America/Iqaluit',
'America/Moncton',
'America/Rankin_Inlet',
'America/Regina',
'America/Resolute',
'America/St_Johns',
'America/Swift_Current',
'America/Toronto',
'America/Vancouver',
'America/Whitehorse',
'America/Winnipeg',
'Atlantic/Cape_Verde',
'America/Cayman',
'Africa/Bangui',
'Africa/Ndjamena',
'America/Punta_Arenas',
'America/Santiago',
'Pacific/Easter',
'Asia/Shanghai',
'Asia/Urumqi',
'Indian/Christmas',
'Indian/Cocos',
'America/Bogota',
'Indian/Comoro',
'Africa/Brazzaville',
'Africa/Kinshasa',
'Africa/Lubumbashi',
'Pacific/Rarotonga',
'America/Costa_Rica',
'Europe/Zagreb',
'America/Havana',
'America/Curacao',
'Asia/Famagusta',
'Asia/Nicosia',
'Europe/Prague',
'Africa/Abidjan',
'Europe/Copenhagen',
'Africa/Djibouti',
'America/Dominica',
'America/Santo_Domingo',
'America/Guayaquil',
'Pacific/Galapagos',
'Africa/Cairo',
'America/El_Salvador',
'Africa/Malabo',
'Africa/Asmara',
'Europe/Tallinn',
'Africa/Addis_Ababa',
'Atlantic/Stanley',
'Atlantic/Faroe',
'Pacific/Fiji',
'Europe/Helsinki',
'Europe/Paris',
'America/Cayenne',
'Pacific/Gambier',
'Pacific/Marquesas',
'Pacific/Tahiti',
'Indian/Kerguelen',
'Africa/Libreville',
'Africa/Banjul',
'Asia/Tbilisi',
'Europe/Berlin',
'Europe/Busingen',
'Africa/Accra',
'Europe/Gibraltar',
'Europe/Athens',
'America/Danmarkshavn',
'America/Nuuk',
'America/Scoresbysund',
'America/Thule',
'America/Grenada',
'America/Guadeloupe',
'Pacific/Guam',
'America/Guatemala',
'Europe/Guernsey',
'Africa/Conakry',
'Africa/Bissau',
'America/Guyana',
'America/Port-au-Prince',
'Europe/Vatican',
'America/Tegucigalpa',
'Asia/Hong_Kong',
'Europe/Budapest',
'Atlantic/Reykjavik',
'Asia/Kolkata',
'Asia/Jakarta',
'Asia/Jayapura',
'Asia/Makassar',
'Asia/Pontianak',
'Asia/Tehran',
'Asia/Baghdad',
'Europe/Dublin',
'Europe/Isle_of_Man',
'Asia/Jerusalem',
'Europe/Rome',
'America/Jamaica',
'Asia/Tokyo',
'Europe/Jersey',
'Asia/Amman',
'Asia/Almaty',
'Asia/Aqtau',
'Asia/Aqtobe',
'Asia/Atyrau',
'Asia/Oral',
'Asia/Qostanay',
'Asia/Qyzylorda',
'Africa/Nairobi',
'Pacific/Kanton',
'Pacific/Kiritimati',
'Pacific/Tarawa',
'Asia/Pyongyang',
'Asia/Seoul',
'Asia/Kuwait',
'Asia/Bishkek',
'Asia/Vientiane',
'Europe/Riga',
'Asia/Beirut',
'Africa/Maseru',
'Africa/Monrovia',
'Africa/Tripoli',
'Europe/Vaduz',
'Europe/Vilnius',
'Europe/Luxembourg',
'Asia/Macau',
'Europe/Skopje',
'Indian/Antananarivo',
'Africa/Blantyre',
'Asia/Kuala_Lumpur',
'Asia/Kuching',
'Indian/Maldives',
'Africa/Bamako',
'Europe/Malta',
'Pacific/Kwajalein',
'Pacific/Majuro',
'America/Martinique',
'Africa/Nouakchott',
'Indian/Mauritius',
'Indian/Mayotte',
'America/Bahia_Banderas',
'America/Cancun',
'America/Chihuahua',
'America/Ciudad_Juarez',
'America/Hermosillo',
'America/Matamoros',
'America/Mazatlan',
'America/Merida',
'America/Mexico_City',
'America/Monterrey',
'America/Ojinaga',
'America/Tijuana',
'Pacific/Chuuk',
'Pacific/Kosrae',
'Pacific/Pohnpei',
'Europe/Chisinau',
'Europe/Monaco',
'Asia/Choibalsan',
'Asia/Hovd',
'Asia/Ulaanbaatar',
'Europe/Podgorica',
'America/Montserrat',
'Africa/Casablanca',
'Africa/El_Aaiun',
'Africa/Maputo',
'Asia/Yangon',
'Africa/Windhoek',
'Pacific/Nauru',
'Asia/Kathmandu',
'Europe/Amsterdam',
'Pacific/Noumea',
'Pacific/Auckland',
'Pacific/Chatham',
'America/Managua',
'Africa/Niamey',
'Africa/Lagos',
'Pacific/Niue',
'Pacific/Norfolk',
'Pacific/Saipan',
'Europe/Oslo',
'Asia/Muscat',
'Asia/Karachi',
'Pacific/Palau',
'Asia/Gaza',
'Asia/Hebron',
'America/Panama',
'Pacific/Bougainville',
'Pacific/Port_Moresby',
'America/Asuncion',
'America/Lima',
'Asia/Manila',
'Pacific/Pitcairn',
'Europe/Warsaw',
'Atlantic/Azores',
'Atlantic/Madeira',
'Europe/Lisbon',
'America/Puerto_Rico',
'Asia/Qatar',
'Europe/Bucharest',
'Asia/Anadyr',
'Asia/Barnaul',
'Asia/Chita',
'Asia/Irkutsk',
'Asia/Kamchatka',
'Asia/Khandyga',
'Asia/Krasnoyarsk',
'Asia/Magadan',
'Asia/Novokuznetsk',
'Asia/Novosibirsk',
'Asia/Omsk',
'Asia/Sakhalin',
'Asia/Srednekolymsk',
'Asia/Tomsk',
'Asia/Ust-Nera',
'Asia/Vladivostok',
'Asia/Yakutsk',
'Asia/Yekaterinburg',
'Europe/Astrakhan',
'Europe/Kaliningrad',
'Europe/Kirov',
'Europe/Moscow',
'Europe/Samara',
'Europe/Saratov',
'Europe/Ulyanovsk',
'Europe/Volgograd',
'Africa/Kigali',
'Indian/Reunion',
'America/St_Barthelemy',
'Atlantic/St_Helena',
'America/St_Kitts',
'America/St_Lucia',
'America/Marigot',
'America/Miquelon',
'America/St_Vincent',
'Pacific/Apia',
'Europe/San_Marino',
'Africa/Sao_Tome',
'Asia/Riyadh',
'Africa/Dakar',
'Europe/Belgrade',
'Indian/Mahe',
'Africa/Freetown',
'Asia/Singapore',
'America/Lower_Princes',
'Europe/Bratislava',
'Europe/Ljubljana',
'Pacific/Guadalcanal',
'Africa/Mogadishu',
'Africa/Johannesburg',
'Atlantic/South_Georgia',
'Africa/Juba',
'Africa/Ceuta',
'Atlantic/Canary',
'Europe/Madrid',
'Asia/Colombo',
'Africa/Khartoum',
'America/Paramaribo',
'Arctic/Longyearbyen',
'Africa/Mbabane',
'Europe/Stockholm',
'Europe/Zurich',
'Asia/Damascus',
'Asia/Taipei',
'Asia/Dushanbe',
'Africa/Dar_es_Salaam',
'Asia/Bangkok',
'Asia/Dili',
'Africa/Lome',
'Pacific/Fakaofo',
'Pacific/Tongatapu',
'America/Port_of_Spain',
'Africa/Tunis',
'Europe/Istanbul',
'Asia/Ashgabat',
'America/Grand_Turk',
'Pacific/Funafuti',
'Africa/Kampala',
'Europe/Kyiv',
'Europe/Simferopol',
'Asia/Dubai',
'Europe/London',
'America/Adak',
'America/Anchorage',
'America/Boise',
'America/Chicago',
'America/Denver',
'America/Detroit',
'America/Indiana/Indianapolis',
'America/Indiana/Knox',
'America/Indiana/Marengo',
'America/Indiana/Petersburg',
'America/Indiana/Tell_City',
'America/Indiana/Vevay',
'America/Indiana/Vincennes',
'America/Indiana/Winamac',
'America/Juneau',
'America/Kentucky/Louisville',
'America/Kentucky/Monticello',
'America/Los_Angeles',
'America/Menominee',
'America/Metlakatla',
'America/New_York',
'America/Nome',
'America/North_Dakota/Beulah',
'America/North_Dakota/Center',
'America/North_Dakota/New_Salem',
'America/Phoenix',
'America/Sitka',
'America/Yakutat',
'Pacific/Honolulu',
'Pacific/Midway',
'Pacific/Wake',
'America/Montevideo',
'Asia/Samarkand',
'Asia/Tashkent',
'Pacific/Efate',
'America/Caracas',
'Asia/Ho_Chi_Minh',
'America/Tortola',
'America/St_Thomas',
'Pacific/Wallis',
'Asia/Aden',
'Africa/Lusaka',
'Africa/Harare',
'Europe/Mariehamn',
  ]);

  let triggerSchema = Yup.object().shape({
    link: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50000, 'Maximum 50 symbols')
      .required('Links are required'),
    description: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(500, 'Maximum 500 symbols')
      .required('Description is required'),

  })

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: 'transparent',
      borderColor: '#4a5568', // Adjust the border color for better visibility
      boxShadow: 'none', // Remove the box shadow
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#4a5568' : '#fffff', // Adjust the background color for focused and non-focused options
      color: state.isFocused ? 'white' : 'black', // Adjust the text color for focused and non-focused options
    }),
  }


  const [userForEdit] = useState<Automation>({
    ...automation,
    link: automation.link || initialUser.link,
    description: automation.description || initialUser.description,
    expression: automation.expression || initialUser.expression,
    timezone: automation.timezone || initialUser.timezone
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  useEffect(() => {
    var data = timezonelist.map((item:any) => ({
      value: item,
      label: item,
    }));
    setoptions(data);
    PasswordMeterComponent.bootstrap()
    setSelectedTimeZone({
      value: automation.timezone || '',
      label: automation.timezone || '',
    })
  }, [])


  useEffect(() => {
    console.log("M->KKKK -> " + automation.expression!);
    setValue(automation.expression!);
  }, [automation])

  const handleTimeZoneChange = (selected:any) => {
    setSelectedTimeZone({
      value: selected.value,
      label: selected.label,
    })

  };

  const formik = useFormik({
    initialValues: userForEdit,
    validationSchema: triggerSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      values.expression = value;
      try {
        if (isNotEmpty(automation._id)) {
          await updateAutomation(values, automation._id, defaultCompany?.company_id ?? '',selectedTimeZone.value)
          setSubmitting(true)
          cancel(true)
        }
        else {
          const apidat: any = await createAutomations(values, defaultCompany?.company_id ?? '',selectedTimeZone.value);
          console.log(apidat);
          if (!apidat.status) {
            toast.error(apidat.message);
          } else {
            setSubmitting(true)
            cancel(true)
          }
        }

      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })




  return (
    <>
      {userListContext.passwordUpdateCheck ? (
        // Show logs or other content when passwordUpdateCheck is true
        <>
          {automation.logs && automation.logs.map((log, index) => (
            <div key={index}>{log}</div>
          ))}
        </>
      ) : (<form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}

          <div>
            <div className='fv-row mb-5 mt-5'>
              <label className='required fw-bold fs-6 mb-2'>Website Links</label>
              {/* end::Label */}

              {/* begin::Input */}
              <textarea
                placeholder='Website link one on each line'
                {...formik.getFieldProps('link')}
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.link && formik.errors.link },
                  {
                    'is-valid': formik.touched.link && !formik.errors.link,
                  }
                )}
                name='link'
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {/* end::Input */}
              {formik.touched.link && formik.errors.link && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.link}</span>
                </div>
              )}

            </div>

            <div className='fv-row mb-5 mt-5'>
              <label className='required fw-bold fs-6 mb-2'>Description</label>

              <textarea
                placeholder='Description'
                {...formik.getFieldProps('description')}
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.description && formik.errors.description },
                  {
                    'is-valid': formik.touched.description && !formik.errors.description,
                  }
                )}
                name='description'
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {/* end::Input */}
              {formik.touched.description && formik.errors.description && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.description}</span>
                </div>
              )}

            </div>
            <div>
              <p>Value: {value}</p>

              <Cron value={value} setValue={setValue} />


            </div>

            <div className='mt-2'>
            <label className='required fw-bold fs-6 mb-2'>Select Timezone</label>

              <Select
                styles={customStyles}
                value={selectedTimeZone}
                onChange={handleTimeZoneChange}
                options={options}
              />
            </div>
          </div>


        </div>

        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>)}
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </>
  )
}

export { AutomationEditForm }
